import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Reuniao } from 'src/app/core/reuniao';
import { ComboPessoaFisica } from '../../../../core/combo-pessoa-fisica';
import { ComboTipoReuniao } from '../../../../core/combo-tipos-reuniao';
import { PessoaFisica } from '../../../../core/pessoa-fisica';
import { TipoReuniao } from '../../../../core/tipo-reuniao';
import { DataUtilService } from '../../../../services/commons/data-util.service';
import { PessoaFisicaService } from '../../../../services/pessoa-fisica/pessoa-fisica.service';
import { TiposReuniaoService } from '../../../../services/tipos-reuniao/tipo-reuniao.service';


@Component({
  selector: 'dados-reuniao',
  templateUrl: './dados-reuniao.component.html',
  styleUrls: ['./dados-reuniao.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class DadosReuniaoComponent implements OnInit {

  @Input() reuniao: Reuniao;

  constructor(private pessoaFisicaService: PessoaFisicaService, 
    private tiposReuniaoService: TiposReuniaoService, private dataUtilService: DataUtilService) {}

  ngOnInit() {}

  onNomeChangePessoaFisica(event: ComboPessoaFisica) {
    if (event) {
      this.carregarDadosPessoaFisica(event);
    } else {
      this.reuniao.relator = undefined;
    }
  }

  onDescricaoChangeTipoReuniao(event: ComboTipoReuniao) {
    if (event) {
      this.carregarTipoReuniao(event);
    } else {
      this.reuniao.tipoReuniao = undefined;
    }
  }

  carregarDadosPessoaFisica(comboPessoaFisica: ComboPessoaFisica) {
    this.pessoaFisicaService.getById(comboPessoaFisica.id).subscribe((pessoaFisica: PessoaFisica) => {
      this.reuniao.relator = pessoaFisica;
    })
  }

  carregarTipoReuniao(comboTipoReuniao: ComboTipoReuniao) {
    this.tiposReuniaoService.getTipoReuniaoById(comboTipoReuniao.id).subscribe((tipoReuniao: TipoReuniao) => {
      this.reuniao.tipoReuniao = tipoReuniao;
    })
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

}
